import { DomainCheckPage } from '../pages/public/tools/DomainCheckPage';

/**
 * Thin route module for /tools/spf-checker.
 *
 * Four routes share DomainCheckPage and differ only by `variant`. The old table passed the prop
 * inline through react-router's `lazy`; framework mode resolves one MODULE per route, so each
 * variant needs its own. One-line wrappers keep the page itself unforked.
 */
export default function ToolRoute() {
  return <DomainCheckPage variant="spf" />;
}
